import React from 'react';
import NotificationList from '../../shared/components/NotificationList';
import { Link } from "react-router-dom";
import Facility from '@/features/facility/shared/types/Facility';

type MainProps = {
  facility?: Facility;
}

const Main: React.FC<MainProps> = ({
  facility
}) => {
  return (
    <main id="page-facility_login" className="wrapper">
      <NotificationList path="top" />
      <div className="sec-link">
        <div className="inner">
          <ul className="link-list">
            <li className="link-list__item">
              <Link to="/facility/stock"> 在庫確認 </Link>
            </li>
            <li className="link-list__item">
              <Link to="/facility/orders/history">注文履歴</Link>
            </li>
            <li className="link-list__item">
              <Link to="/facility/orders/index">レンズ注文</Link>
            </li>
            {facility?.isPromoCare &&
              <li className="link-list__item">
                <Link to="/facility/orders/promo_care"> ケア用品・販促品注文</Link>
              </li>
            }
            {facility?.isFlatRate &&
              <li className="link-list__item">
                <Link to="/facility/flat_rates/index"> 定額制契約 </Link>
              </li>
            }
            {facility?.isFacilityFlatRate &&
              <li className="link-list__item">
                <Link to="/facility/facility_agreements/index"> 施設型定額制契約 </Link>
              </li>
            }
          </ul>
        </div>
      </div>
    </main>
  )
}

export default Main;